module.exports = __webpack_public_path__ + "static/img/3.83fbcd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/3.png
// module id = Wheh
// module chunks = 0